import { Switch } from 'antd';
import styled from 'styled-components';

export const SwitchLabelWrapper = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
`;

export const StyledSwitch = styled(Switch)<{ $customColor?: string }>`
  ${({ $customColor }) =>
    $customColor &&
    `
    &.ant-switch-checked {
      background-color: ${$customColor};
    }
    
    &.ant-switch-checked:hover:not(.ant-switch-disabled) {
      background: ${$customColor};
    }
  `}
`;
